import { apiPostNoAuth } from "../../utils/Axios/axios";

const VIEW_VERIFIABLE_CREDENTIAL = `${process.env.REACT_APP_SFE_SERVER_URL}/finance/view_verifiable_credential`;

export const viewVerifiableCredential = (apiData) => {
  return apiPostNoAuth(VIEW_VERIFIABLE_CREDENTIAL, apiData);
};
